<template>
    <ui-modal small>
        <template #header>
            <h3 v-text="'Zamykanie worka'" />
        </template>
        <page-preloader v-if="isLoading" min-height="200px" />
        <template v-else>
            <div
                class="a-infoBar a-infoBar--warning text-sm"
                v-text="`Załóż plombę na worek i wpisz jej numer. Pamiętaj, że do worka
                oznaczonego jako zamknięty nie można wrzucać kolejnych opakowań.`"
            />

            <div class="card text-sm text-primary gap-0-5 p-3 my-3 ">
                <div class="row">
                    <span
                        v-text="'Frakcja'"
                        class="font-weight-bold col"
                    />
                    <fraction-label
                        class="text-primary col"
                        :fraction="fraction"
                    />
                </div>

                <div class="row">
                    <span class="col d-flex align-items-center font-weight-bold">
                        Preferowany operator
                        <a-icon
                            v-tooltip="`Każdy operator posiada dedykowane numery plomb.<br/>
                                Po wprowadzeniu numeru automatycznie pojawi się informacja o operatorze,<br/>
                                któremu wydasz worek. Warto zamykać worek plombą preferowanego operatora`"
                            icon="Info"
                            height="16"
                        />
                    </span>
                    <span v-text="operatorName" class="col" />
                </div>

                <div class="row">
                    <span class="col d-flex align-items-center font-weight-bold">
                        Wartość worka
                        <a-icon
                            v-tooltip="`Na wartość worka składa się liczba sztuk przemnożona przez opłatę operatora`"
                            icon="Info"
                            height="16"
                        />
                    </span>
                    <span class="col">
                        <strong v-text="total" />
                        ({{ quantity }} szt.)
                    </span>
                </div>
            </div>

            <the-input
                v-model="sealNumber"
                required
                class="m-0"
                label="Wpisz numer plomby"
                tooltip="Numer znajduje się na fizycznej plombie dostarczonej przez operatora"
                :maxlength="$options.sealNumberMaxLength"
                :text="sealNumber"
            />
        </template>
        <template #footer>
            <the-btn
                class="btn-outline-custom"
                text="Zamknij"
                :disabled="isLoading"
                @click="$emit('close-modal')"
            />
            <the-btn
                v-tooltip="!sealNumber && 'Wpisz numer plomby'"
                class="btn-secondary"
                text="Zamknij worek"
                :disabled="isLoading || !sealNumber"
                @click="onConfirm"
            />
        </template>
    </ui-modal>
</template>

<script>
import { mapActions } from 'vuex'
import { SEAL_NUMBER_VALID_LENGTH } from '@/store/modules/drs/drs-stores-bags.module'
import bagsMixin from '@/components/drs/stores/bags/bags.mixin'

export default {
    sealNumberMaxLength: SEAL_NUMBER_VALID_LENGTH,

    mixins: [bagsMixin],

    data: () => ({
        sealNumber: null,
        isLoading: false
    }),

    created() {
        if (this.args.sealNumber) {
            this.sealNumber = this.args.sealNumber
        }
    },

    computed: {
        args() {
            return this.$store.getters.getModal.args
        },

        bag() {
            return this.args.bag
        }
    },

    methods: {
        ...mapActions('drsBags', ['closePackage']),

        async onConfirm() {
            this.isLoading = true

            // validate seal prefix
            if (this.isSealNumberUnknown || this.isSealPrefixNotPreferred) {
                this.isLoading = false
                this.goToSealPrefixWarning()
                return
            }

            // close bag
            await this.submitCloseBag()

            this.isLoading = false
            this.$emit('close-modal')
        },

        async submitCloseBag() {
            await this.closePackage({
                mcuid: this.bag.mcuid,
                fractions: this.bag.fractions,
                seal_number: this.sealNumber,
                package_id: this.bag.package_id
            })
        },

        goToSealPrefixWarning() {
            this.$store.dispatch('openModal', {
                componentPath: 'drs/stores/bags/SealPrefixWarning',
                args: {
                    ...this.args,
                    sealNumber: this.sealNumber,
                    onAcceptBtn: () => this.submitCloseBag(),
                    onRejectBtn: (args) => {
                        this.$store.dispatch('openModal', {
                            componentPath: 'drs/stores/bags/CloseBag',
                            args
                        })
                    }
                }
            })
        }
    }
}
</script>